export const MILE_IN_METERS = 1609.344

export default (miles: number): number => {
  return miles * MILE_IN_METERS
}
